import { CheckCircle, Loader2, XCircle } from "lucide-react";
import React from "react";

const STALE_THRESHOLD_MS = 20 * 60 * 1000; // 20 minutes

interface FetchStatusBadgeProps {
  startedAtUtc: string;
  finishedAtUtc: string | null;
}

const FetchStatusBadge: React.FC<FetchStatusBadgeProps> = ({ startedAtUtc, finishedAtUtc }) => {
  if (startedAtUtc && !finishedAtUtc) {
    const elapsed = Date.now() - new Date(startedAtUtc).getTime();
    if (elapsed > STALE_THRESHOLD_MS) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded text-xs font-medium bg-red-100 text-red-800">
          <XCircle className="w-3 h-3" />
          Failed
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded text-xs font-medium bg-yellow-100 text-yellow-800">
        <Loader2 className="w-3 h-3 animate-spin" />
        In Progress
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">
      <CheckCircle className="w-3 h-3" />
      Complete
    </span>
  );
};

export default FetchStatusBadge;
